// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep ul {
  display: inline-block;
}
:host ::ng-deep li {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_custompage/U2000_loginnobusinesslink.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourcesContent":[":host {\n    ::ng-deep ul {\n        display: inline-block;\n    }\n\n    ::ng-deep li {\n        text-align: left;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
